import { msalInstance } from '@/application/auth/config/msalInstance'
import { loginRequest } from '@/application/auth/config/msalConfig'

export const getAccessToken = async (): Promise<string | null> => {
  try {
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length === 0) {
      return null
    }

    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    })

    return response.accessToken
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to acquire token silently:', error)
    return null
  }
}
